import React, { useState } from "react";
import classNames from "classnames";
import LoadingSpinner from "@/components/loading-spinner/LoadingSpinner";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import ContactMethods from "@/components/contact-details-box/contact-methods/ContactMethods";
import SlideIn from "@/components/slide-in/SlideIn";
import { useDecisionTreeLocation } from "@/hooks";
import styles from "./screens.module.scss";


function SolutionBrandSupportViewContactDetail({ supplierContactConfig }) {
  const [showContactDetails, setShowContactDetails] = useState(false);
  const location = useDecisionTreeLocation();

  return (
    <div className={styles.solutionViewContactDetailsContainer}>
      <p>Contact John Lewis & Partners Customer Service</p>
      {!showContactDetails && (
        <UnderlinedButton
          className={classNames(styles.downChevron)}
          onClick={() => setShowContactDetails(true)}
        >
          View contact details
        </UnderlinedButton>
      )}
      {showContactDetails && !supplierContactConfig && <LoadingSpinner />}
      {showContactDetails && supplierContactConfig && (
        <SlideIn>
          <ContactMethods
            title="Contact John Lewis & Partners Customer Service"
            fields={[
              { name: "phone", key: "number" },
              { name: "chat", key: "channel" }
            ].map(obj =>
              supplierContactConfig[obj.name]
                ? {
                    name: obj.name,
                    content: supplierContactConfig[obj.name][obj.key]
                  }
                : null
            )}
            solutionId={supplierContactConfig.solution}
            location={location}
            contactDetails={supplierContactConfig}
          />
        </SlideIn>
      )}
    </div>
  );
}

export default SolutionBrandSupportViewContactDetail;
